module.exports = __webpack_public_path__ + "static/media/40-4.a4b19d7d.mp3";